import React, { FC } from "react";

export const NoMatchPage: FC<{}> = () => {
  return <>No match found</>;
};
